<form [formGroup]="formGroup" id="step4Form">
  <div class="step4-form-container">
    <div class="row">
      @if (controls.inPolandAtApplicationSubmition; as inPolandAtApplicationSubmition) {
        <div class="standard-form-field radio-form-field inPolandAtApplicationSubmition-field required-field">
          <label
            id="applicantInPolandAtApplicationSubmitionLabel"
            [class.invalid]="inPolandAtApplicationSubmition.touched && inPolandAtApplicationSubmition.invalid">
            {{ 'IN_POLAND_AT_APPLICATION_SUBMITION.INFIELD-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="applicantInPolandAtApplicationSubmition"
            aria-labelledby="applicantInPolandAtApplicationSubmitionLabel"
            formControlName="inPolandAtApplicationSubmition"
            (keydown)="firstInputKeydown($event)"
            [required]="true"
            [attr.aria-invalid]="
              inPolandAtApplicationSubmition.touched && inPolandAtApplicationSubmition.invalid ? 'true' : null
            ">
            <mat-radio-button [value]="true" id="inPolandAtApplicationSubmition-0">
              {{ 'COMMON.GENERAL.YES' | translate }}
            </mat-radio-button>
            <mat-radio-button [value]="false" id="inPolandAtApplicationSubmition-1">
              {{ 'COMMON.GENERAL.NO' | translate }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      }
    </div>

    @if (controls.inPolandAtApplicationSubmition.value === true) {
      <div class="row">
        @if (controls.currentlyLivingInPoland; as currentlyLivingInPoland) {
          <div class="standard-form-field radio-form-field currentlyLivingInPoland-field required-field">
            <label
              id="applicantCurrentlyLivingInPolandLabel"
              [class.invalid]="currentlyLivingInPoland.touched && currentlyLivingInPoland.invalid">
              {{ 'PERSONAL_DATA_FORM.RESIDENCE-CURRENTLY-LIVING-IN-POLAND.INFIELD-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-radio-group
              id="applicantCurrentlyLivingInPoland"
              aria-labelledby="applicantCurrentlyLivingInPolandLabel"
              formControlName="currentlyLivingInPoland"
              (keydown)="firstInputKeydown($event)"
              [attr.aria-invalid]="currentlyLivingInPoland.touched && currentlyLivingInPoland.invalid ? 'true' : null">
              <mat-radio-button [value]="true" id="applicantCurrentlyLivingInPoland-0">
                {{ 'COMMON.GENERAL.YES' | translate }}
              </mat-radio-button>
              <mat-radio-button [value]="false" id="applicantCurrentlyLivingInPoland-1">
                {{ 'COMMON.GENERAL.NO' | translate }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
        }
      </div>
    }
    @if (
      controls.inPolandAtApplicationSubmition.value === true &&
      (controls.currentlyLivingInPoland.value === true || controls.currentlyLivingInPoland.value === false)
    ) {
      <div class="row">
        @if (controls.legalBasisOfStay; as legalBasisOfStay) {
          <div class="standard-form-field widened-field legalBasisOfStay-field required-field">
            <label
              id="applicantLegalBasisOfStayLabel"
              [class.invalid]="legalBasisOfStay.touched && legalBasisOfStay.invalid">
              {{
                controls.currentlyLivingInPoland.value === true
                  ? ('PERSONAL_DATA_FORM.LEGAL-BASIS-OF-STAY.MAIN-LABEL' | translate)
                  : ('PERSONAL_DATA_FORM.PLANNED-LEGAL-BASIS-OF-STAY.MAIN-LABEL' | translate)
              }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <mat-select
                id="applicantLegalBasisOfStay"
                panelClass="standard-select"
                placeholder=""
                formControlName="legalBasisOfStay"
                [attr.aria-required]="true"
                [attr.aria-labelledby]="'applicantLegalBasisOfStayLabel'"
                [attr.aria-invalid]="legalBasisOfStay.touched && legalBasisOfStay.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  legalBasisOfStay.touched && legalBasisOfStay.invalid ? 'legalBasisOfStayError' : null
                ">
                @for (item of legalBasisOfStayList.permStay; track item) {
                  <mat-option [value]="item.value">
                    {{ 'SELECTS_VALUES.STAY_LEGAL_BASIS_NEW.' + item.labelKey | translate }}
                  </mat-option>
                }
              </mat-select>
              <!-- ERROR -->
              @if (legalBasisOfStay.touched && legalBasisOfStay.invalid) {
                <mat-error id="legalBasisOfStayError">
                  {{ legalBasisOfStay.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
        @if (controls.residenceVisaExpiryDate; as residenceVisaExpiryDate) {
          <div class="standard-form-field residenceVisaExpiryDate-field required-field">
            <label
              for="applicantResidenceVisaExpiryDatePicker"
              [class.invalid]="
                (residenceVisaExpiryDate.touched && residenceVisaExpiryDate.invalid) ||
                formGroup.errors?.visaExpiredBeforeLastEntryDate
              ">
              {{ 'PERSONAL_DATA_FORM.RESIDENCE-VISA-EXPIRY-DATE.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline" (click)="residenceVisaExpiryDatePicker.open()">
              <input
                matInput
                id="applicantResidenceVisaExpiryDatePicker"
                #applicantResidenceVisaExpiryDatePicker
                readonly
                (focus)="residenceVisaExpiryDatePicker.open()"
                [matDatepicker]="residenceVisaExpiryDatePicker"
                [min]="currentDate"
                [max]="maxValidDocumentExpiryDate"
                placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-VISA-EXPIRY-DATE.PLACEHOLDER' | translate }}"
                formControlName="residenceVisaExpiryDate"
                [attr.aria-required]="true"
                [attr.aria-invalid]="residenceVisaExpiryDate.touched && residenceVisaExpiryDate.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  residenceVisaExpiryDate.touched && residenceVisaExpiryDate.invalid
                    ? 'residenceVisaExpiryDateError'
                    : null
                " />
              <mat-datepicker-toggle
                matSuffix
                [for]="residenceVisaExpiryDatePicker"
                aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
              </mat-datepicker-toggle>
              <mat-datepicker
                #residenceVisaExpiryDatePicker
                [startView]="'month'"
                [startAt]="residenceVisaExpiryDate.value || documentExpiryPickerStartDate"
                (closed)="applicantResidenceVisaExpiryDatePicker.blur()">
              </mat-datepicker>
              <!-- ERROR -->
              @if (residenceVisaExpiryDate.touched && residenceVisaExpiryDate.invalid) {
                <mat-error id="residenceVisaExpiryDateError">
                  {{ residenceVisaExpiryDate.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
      <div class="row">
        @if (controls.lastEntryDate; as lastEntryDate) {
          <div class="standard-form-field widened-field lastEntryDate-field required-field">
            <label for="applicantLastEntryDate" [class.invalid]="lastEntryDate.touched && lastEntryDate.invalid">
              {{
                controls.currentlyLivingInPoland.value === true
                  ? ('PERSONAL_DATA_FORM.LAST-ENTRY-DATE-PERM-STAY.MAIN-LABEL' | translate)
                  : ('PERSONAL_DATA_FORM.PLANNED-ENTRY-DATE.MAIN-LABEL' | translate)
              }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline" (click)="lastEntryDatePicker.open()">
              <input
                matInput
                id="applicantLastEntryDate"
                #applicantLastEntryDate
                readonly
                (focus)="lastEntryDatePicker.open()"
                [matDatepicker]="lastEntryDatePicker"
                placeholder="{{ 'PERSONAL_DATA_FORM.LAST-ENTRY-DATE-PERM-STAY.PLACEHOLDER' | translate }}"
                [min]="controls.currentlyLivingInPoland.value === true ? null : currentDate"
                [max]="controls.currentlyLivingInPoland.value === true ? currentDate : null"
                formControlName="lastEntryDate"
                [attr.aria-required]="true"
                [attr.aria-invalid]="lastEntryDate.touched && lastEntryDate.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  lastEntryDate.touched && lastEntryDate.invalid ? 'lastEntryDateEntry' : null
                " />
              <mat-datepicker-toggle
                matSuffix
                [for]="lastEntryDatePicker"
                aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
              </mat-datepicker-toggle>
              <mat-datepicker
                #lastEntryDatePicker
                [startAt]="currentDate"
                [startView]="'month'"
                (closed)="applicantLastEntryDate.blur()">
              </mat-datepicker>
              <!-- ERROR -->
              @if (lastEntryDate.touched && lastEntryDate.invalid) {
                <mat-error id="lastEntryDateEntry">
                  {{ lastEntryDate.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
            <!-- ERROR -->
            @if (formGroup.errors?.VISA_EXPIRED_BEFORE_LAST_ENTRY_DATE) {
              <mat-error>
                {{ 'COMMON.VALIDATOR.VISA_EXPIRED_BEFORE_LAST_ENTRY_DATE' | translate }}
              </mat-error>
            }
          </div>
        }
      </div>
      <div class="row">
        @if (controls.purposeOfStay; as purposeOfStay) {
          <div class="standard-form-field widened-field purposeOfStay-field required-field">
            <label for="purposeOfStayInput" [class.invalid]="purposeOfStay.touched && purposeOfStay.invalid">
              {{ 'PERSONAL_DATA_FORM.PURPOSE-OF-STAY.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <mat-select
                id="purposeOfStayInput"
                panelClass="standard-select"
                placeholder=""
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-invalid]="purposeOfStay.touched && purposeOfStay.invalid ? 'true' : null"
                [attr.aria-describedby]="purposeOfStay.touched && purposeOfStay.invalid ? 'purposeOfStayError' : null"
                formControlName="purposeOfStay">
                @for (item of purposeOfStayList; track item) {
                  <mat-option [value]="item">
                    {{ 'PROCESSES.ORIG_PROCESSES.' + item | translate }}
                  </mat-option>
                }
              </mat-select>
              <!-- ERROR -->
              @if (purposeOfStay.touched && purposeOfStay.invalid) {
                <mat-error id="purposeOfStayError">
                  {{ purposeOfStay.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
      @if (showStayVisaFields) {
        <app-partial-stay-visa
          [controls]="controls"
          [minValidDate]="minValidDate"
          [maxValidDate]="maxValidDate"
          [maxValidFutureDate]="maxValidFutureDate"
          [documentIssuePickerStartDate]="documentIssuePickerStartDate"
          [documentExpiryPickerStartDate]="documentExpiryPickerStartDate"
          [visaTypes]="visaTypes">
        </app-partial-stay-visa>
      }
      @if (showEntitlingDocumentFields) {
        <app-partial-entitling-document
          [controls]="controls"
          [minValidDate]="minValidDate"
          [maxValidDate]="maxValidDate"
          [documentIssuePickerStartDate]="documentIssuePickerStartDate">
        </app-partial-entitling-document>
      }
      @if (showEntryDocumentFields) {
        <app-partial-entry-document
          [controls]="controls"
          [minValidDate]="minValidDate"
          [maxValidDate]="maxValidDate"
          [maxValidFutureDate]="maxValidFutureDate"
          [documentIssuePickerStartDate]="documentIssuePickerStartDate"
          [documentExpiryPickerStartDate]="documentExpiryPickerStartDate">
        </app-partial-entry-document>
      }
    }

    <div class="row">
      <div class="standard-form-field previousStaysInRP-field radio-form-field required-field">
        <label> {{ 'PERSONAL_DATA_FORM.PREVIOUS-STAYS-IN-RP.MAIN-LABEL' | translate }} * </label>
      </div>
    </div>

    <div class="row visits-row">
      <app-previous-visits-form-perm-stay
        [previousVisitsArrFc]="controls.previousVisitsArr"
        [disabled]="controls.previousVisitsArr.disabled"
        [inPolandAtApplicationSubmition]="controls.inPolandAtApplicationSubmition"
        [lastEntryDateFc]="controls.lastEntryDate"
        [legalBasisOfStayFc]="controls.legalBasisOfStay"
        [legalBasisOfStayCommentFc]="controls.legalBasisOfStayComment"
        [currentlyLivingInPolandFc]="controls.currentlyLivingInPoland">
      </app-previous-visits-form-perm-stay>
    </div>

    <nz-divider [nzText]="travelersOrStays" nzOrientation="center">
      <ng-template #travelersOrStays>
        <h5>{{ 'PERSONAL_DATA_FORM.TRAVELERS_AND_STAYS_OUTSIDE_POLAND' | translate }}</h5>
      </ng-template>
    </nz-divider>

    <div class="row">
      @if (controls.noLastTravelsOutsidePoland; as noLastTravelsOutsidePoland) {
        <div class="standard-form-field radio-form-field noLastTravelsOutsidePoland-field required-field">
          <label
            id="noLastTravelsOutsidePolandLabel"
            [class.invalid]="noLastTravelsOutsidePoland.touched && noLastTravelsOutsidePoland.invalid">
            {{ 'PERSONAL_DATA_FORM.LAST-TRAVELS-OUTSIDE-POLAND.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <!-- IMPORTANT about noLastTravelsOutsidePoland
                                        there is fuckup because of different label text!
                                        the field is 'noLastTravelsOutsidePoland' so it would mean that
                                        if noLastTravelsOutsidePoland === true then user DID NOT have any travels outside poland.
                                        BUT! !IMPORTANT! current label for this field is: 'Czy przekraczałeś granice krajów innych niż Polska w przeciągu ostatnich 5 lat?'
                                        so if user marks YES then it means that we have to set our field value to `false` as user DID HAVE TRAVELS OUTSIDE POLAND
                                        -->
          <mat-radio-group
            id="noLastTravelsOutsidePoland"
            aria-labelledby="noLastTravelsOutsidePolandLabel"
            formControlName="noLastTravelsOutsidePoland"
            [required]="true"
            [attr.aria-invalid]="
              noLastTravelsOutsidePoland.touched && noLastTravelsOutsidePoland.invalid ? 'true' : null
            "
            (keydown.Tab)="noLastTravelsOutsidePoland.value === false ? undefined : emitLastFieldTabPressed($event)">
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      }
      @if (controls.noLastTravelsOutsidePoland.value === false && visitsAmount > 1 && mode === 'employee') {
        <cr-button
          class="sort-button"
          [isLoading]="isVisitsSorting"
          [isDisabled]="isVisitsLoading"
          (clicked)="sortClick$.next()">
          {{ 'COUNTRIES_VISITS_FORM.SORT_VISITS' | translate }}
        </cr-button>
      }
    </div>

    @if (controls.noLastTravelsOutsidePoland.value === false) {
      <div class="row visits-row">
        <app-countries-visits-form-perm-stay
          [lastTravelsOutsidePoland]="controls.lastTravelsOutsidePoland"
          [disabled]="controls.lastTravelsOutsidePoland.disabled"
          [triggerSort]="sortClick$"
          (sortingChanged)="onVisitsSortingChange($event)"
          (loadingChanged)="onVisitsLoadingChange($event)"
          (lastFieldTabPressed)="emitLastFieldTabPressed($event)">
        </app-countries-visits-form-perm-stay>
      </div>
    }
  </div>
</form>
